import api from 'api';

export const loadUsers = api('GET /api/api-integrations/fields/users');

export const loadActiveUsers = api(
  'GET /api/api-integrations/fields/users/active'
);

export const loadPartnerCompany = api(
  'GET /api/api-integrations/fields/partner-company'
);

export const loadActivePartnerCompany = api(
  'GET /api/api-integrations/fields/partner-company/active'
);

export const loadAffiliates = api(
  'GET /api/api-integrations/fields/affiliates'
);

export const loadActiveAffiliates = api(
  'GET /api/api-integrations/fields/affiliates/active'
);

export const loadNetworks = api('GET /api/api-integrations/fields/networks');

export const loadPartnersApi = api(
  'GET /api/api-integrations/fields/partners-api'
);

export const loadOpenPeriodCostModelCampaigns = api(
  'GET /api/api-integrations/fields/open-period-cost-model-campaigns'
);
